export default {"src":"/_next/static/media/People-animation.f9dcfb35.gif","height":1084,"width":1930};